module.exports = __webpack_public_path__ + "img/avatar0.579546b4.png";